export const environment = {
  msalConfig: {
    auth: {
      tenantId: 'b5fc2c61-76a2-40e2-ba4e-e12c0967b898',
      clientId: '8b05197b-00ec-4ae0-ac55-849521b27181',
    },
  },
};
